<!-- The designer's flow frame (Figma 28547:27443 / 28547:27273 / 28520:21850): header, stepper,
     the step. "Your library" has no stepper. -->
<div class="render-flow is-cream">
  <div class="flow-shell">
    <header class="flow-header">
      <a class="flow-header__mark" [href]="homeUrl" (click)="goHome($event)" aria-label="3DWay render home">3DWay</a>
      <div class="flow-header__actions">
        <!-- No "?" here (owner, 2026-10-06): the export guide opens where a problem shows — the
             refused drop, the texture checklist, the error page — and from the zone's link. -->
        <a class="flow-header__home" [href]="homeUrl" (click)="goHome($event)">
          <svg class="flow-header__chevron" width="12" height="12" viewBox="0 0 11.7625 11.3125" fill="none" aria-hidden="true"><path d="M1.00002 5.125L5.88127 1L10.7625 5.125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Back to home
        </a>
        <!-- The profile button (designer, 2026-09-25), Library in its menu: last in the row, where it
             is on the landing, so it stays put between the two pages (owner). -->
        <app-render-profile-menu [current]="isLibrary ? 'library' : null"></app-render-profile-menu>
      </div>
    </header>

    <!-- Stepper: a filled circle for the step you are on, a heavy line leading on from it; the
         steps behind you lead back, the ones ahead are not links. The chevron: step 1 only. -->
    <nav *ngIf="!isLibrary" class="stepper" aria-label="Your progress">
      <button *ngIf="canGoBack" class="stepper__back" type="button" (click)="goBack()" aria-label="Back to home">
        <svg width="14" height="14" viewBox="0 0 13.7194 13.2784" fill="none" aria-hidden="true"><path d="M1.09093 5.96591L6.85969 1.09091L12.6284 5.96591" stroke="currentColor" stroke-width="2.18182" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <ol class="stepper__list">
        <li *ngFor="let crumb of shownCrumbs; let last = last" class="stepper__item" [class.is-current]="crumb.number === currentCrumb" [attr.aria-current]="crumb.number === currentCrumb ? 'step' : null">
          <button *ngIf="canReturnTo(crumb.number); else plainStep" class="stepper__step" type="button" (click)="returnTo(crumb.number)">
            <ng-container *ngTemplateOutlet="stepContent; context: { $implicit: crumb }"></ng-container>
          </button>
          <ng-template #plainStep>
            <span class="stepper__step"><ng-container *ngTemplateOutlet="stepContent; context: { $implicit: crumb }"></ng-container></span>
          </ng-template>
          <span *ngIf="!last" class="stepper__line" [class.is-heavy]="crumb.number === currentCrumb" aria-hidden="true"></span>
        </li>
      </ol>
      <ng-template #stepContent let-crumb>
        <b class="stepper__number">{{ crumb.number }}</b><span class="stepper__label">{{ crumb.label }}</span>
      </ng-template>
    </nav>

    <main id="render-flow-main" tabindex="-1">
      <div *ngIf="notice" class="rf-notice flow-message" [class.rf-notice--error]="notice.tone === 'error'" [class.rf-notice--success]="notice.tone === 'success'" role="status">
        {{ notice.text }}
      </div>
      <router-outlet></router-outlet>
    </main>

    <!-- A run that ended on a model you are not looking at: the window's lower right, over the page. -->
    <div class="flow-toasts" aria-live="polite">
      <div *ngFor="let toast of toasts; trackBy: trackToast" class="flow-toast" [class.is-failed]="toast.failed" role="status">
        <svg *ngIf="!toast.failed; else failedMark" class="flow-toast__mark" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 8.5 6.2 12.2 13.5 4.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <ng-template #failedMark><svg class="flow-toast__mark" width="16" height="16" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></ng-template>
        <p class="flow-toast__text"><strong>{{ toast.name }}</strong>{{ toast.text }}</p>
        <a class="flow-toast__action" [routerLink]="toast.url">{{ toast.action }}</a>
        <button class="flow-toast__close" type="button" aria-label="Dismiss" (click)="dismissToast(toast.modelId)">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 2.5l7 7M9.5 2.5l-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
        </button>
      </div>
    </div>
  </div>
</div>
